import {
  Card,
  Stack,
  Title,
  Text,
  Button,
  Textarea,
} from '@mantine/core';
import FullscreenBackground from './FullscreenBackground';

function PromptCollection({
  promptsPerPlayer,
  submittedPrompts,
  promptText,
  setPromptText,
  onSubmitPrompt,
}) {
  // All prompts submitted — fullscreen background below header
  if (submittedPrompts.length >= promptsPerPlayer) {
    return <FullscreenBackground image="/prompts-submitted-bg.png" />;
  }

  // Prompt input form
  return (
    <Card
      shadow="xl"
      p="md"
      radius="lg"
    >
      <Stack gap="sm">
        <Title order={2} size="1.4rem" c="purple" ta="center">
          Prompt {submittedPrompts.length + 1} of {promptsPerPlayer}
        </Title>

        <Textarea
          placeholder="Write something funny and edgy..."
          value={promptText}
          onChange={(e) => setPromptText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey && promptText.trim()) {
              e.preventDefault();
              onSubmitPrompt();
            }
          }}
          rows={2}
          maxLength={150}
          size="lg"
          styles={{
            input: {
              fontSize: '1.2rem',
              lineHeight: 1.4,
            }
          }}
        />
        <Text size="xs" c="dimmed" ta="right">
          {promptText.length}/150
        </Text>

        <Button
          size="lg"
          fullWidth
          onClick={onSubmitPrompt}
          disabled={!promptText.trim()}
          style={{ fontSize: '1.2rem', height: '48px' }}
          color="purple"
        >
          Submit Prompt
        </Button>
      </Stack>
    </Card>
  );
}

export default PromptCollection;
